import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import TVGuide from './components/epg/components/TVGuide';
import Header from './components/header';
import ListaCanais from './views/ListaCanais';
import Watch from './views/Watch';
import Account from './views/Account';
import Pass from './views/Pass';
import DeviceManager from './views/DeviceManager';
import Ativar from './views/Ativar';
import UserAccess from './views/UserAccess';
import LogoutAll from './views/LogoutAll';
import DetalheEvento from './views/DetalheEvento';
import WatchVOD from './views/WatchVOD';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 599px)').matches);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 599px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}

function App() {
  const isMobile = useIsMobile();

  return (
    <>
      <Header />

      {isMobile ? (
        <Switch>
          <Route path="/app/account" exact component={Account} />
          <Route path="/app/password" component={Pass} />
          <Route path="/app/ativar" component={Ativar} />
          <Route path="/app/device_manager" component={DeviceManager} />
          <Route path="/app/user_access" component={UserAccess} />
          <Route path="/app/logout_all" component={LogoutAll} />
          <Redirect to="/app/account" />
        </Switch>
      ) : (
        <Switch>
          <Route path="/app/inicio" component={Watch} />
          <Route path="/app/detalhe/:epg_uuid" component={DetalheEvento} />
          <Route path="/app/watch-vod/:uuid" component={WatchVOD} />
          {/* <Route path="/app/watch" component={Watch} /> */}
          <Route path="/app/guide" component={TVGuide} />
          <Route path="/app/account" component={Account} />
          <Route path="/app/ativar" component={Ativar} />
          <Route path="/app/password" component={Pass} />
          <Route path="/app/device_manager" component={DeviceManager} />
          <Route path="/app/user_access" component={UserAccess} />
          <Route path="/app/logout_all" component={LogoutAll} />
        </Switch>
      )}

    </>
  )
}

export default App;